/*
 * @Descripttion:
 * @version:
 * @Author: pengmiaopei
 * @Date: 2021-07-24 15:21:44
 * @LastEditors: pengmiaopei
 * @LastEditTime: 2021-11-28 13:47:54
 * @Description: file content
 * @FilePath: \Design_Vue_pmp\src\router\index.js
 */
/**
 * @Author: WeiZisen
 * @Date: 2020-11-06 13:53:14
 * @LastEditors: WeiZisen
 * @LastEditTime: 2021-05-27 10:08:45
 * @Description: 请输入一段描述
 * @FilePath: \Vue_RebarProcess\src\router\index.js
 */
/**
 * @description router全局配置，如有必要可分文件抽离，其中asyncRoutes只有在intelligence模式下才会用到，pro版只支持remixIcon图标
 * hidden:true                        是否显示在菜单中显示路由（默认值：false）
 * alwaysShow:true                    当只有一级子路由时是否显示父路由是否显示在菜单中显示路由（默认值：false）
 * name:"Demo"                        首字母大写，一定要与vue文件的name对应起来，用于noKeepAlive缓存控制（该项特别重要）
 * menuHidden:true                    常规/横向/纵向模式中，隐藏根布局，仅适用于第一层路由
 * meta:{
    title:"title"                     菜单、面包屑、多标签页显示的名称
    roles:["admin","..."]             当config/settings.js中rolesControl配置开启时，用于控制角色
    roles: {
      role: ["admin"],                role: ["admin"]
      ability: ["READ","WRITE"],      ability: ["READ","WRITE"],
      mode: "allOf"                   allOf: 数组内所有角色都拥有，返回True
                                      oneOf: 数组内拥有任一角色，返回True(等价第1种数据)
                                      except: 不拥有数组内任一角色，返回True(取反)
    }
    remixIcon:""                      remix图标
    isCustomSvgIcon:false,            是否是自定义svg图标（默认值：false，如果设置true，那么需要把你的svg拷贝到icon/remixIcon下，然后remixIcon字段配置上你的图标名）
    noKeepAlive:true                  当前路由是否不缓存（默认值：false）
    affix:true                        当前路由是否固定多标签页
    badge:"New"                       badge小标签（只支持子级）
    tagHidden:true                    当前路由是否不显示多标签页
   }
 */
import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login'),
    hidden: true,
  },

  {
    path: '/403',
    name: '403',
    component: () => import('@/views/403'),
    hidden: true,
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/404'),
    hidden: true,
  },
  {
    path: '/flowtest',
    name: 'FlowTest',
    component: () => import('@/views/flowtest'),
    hidden: true,
  },
  {
    path: '/refresh',
    name: 'refresh',
    component: () => import('@/common/components/Refresh'),
    hidden: true,
  },
  {
    path: '/modelviewer',
    name: 'modelviewer',
    component: () => import('@/views/modelView/index'),
    hidden: true,
  },
  /*流程相关的页面*/

  // {
  //   path: '/flow/obsdef-flow',
  //   name: 'OBSdefFlow',
  //   component: () => import('@/views/02prjplan/obsdef-flow'),
  //   hidden: true,
  //   meta: {
  //     title: '设计OBS定义_流程',
  //   },
  // },
];
// 3. 创建 router 实例，
const router = createRouter();

export function resetRouter(routes = constantRoutes) {
  router.matcher = createRouter(routes).matcher;
}
/**
 * @description:使用new VueRouter，创建 router 实例，
 * @param {*} routes
 * @return {*}
 */
function createRouter(routes = constantRoutes) {
  return new VueRouter({
    // base: publicPath,
    // mode: routerMode,
    scrollBehavior: () => ({
      y: 0,
    }),
    routes: routes,
  });
}
//@ 注销后重新登录携带参数
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};

export default router;
